import React from "react";
import { Row, Col, Input, Label, FormFeedback } from "reactstrap";
import Select from "react-select";

const EligibilityForm = ({ validation }: { validation: any }) => {
  // Age options (01–100 example)
  const ageOptions = Array.from({ length: 100 }, (_, i) => ({
    label: i + 1 < 10 ? `0${i + 1}` : `${i + 1}`,
    value: i + 1,
  }));

  return (
    <Row className="g-4">

      {/* Minimum Entry Age */}
      <Col md={4}>
        <Label className="fw-bold mb-1">Minimum Entry Age</Label>
        <Select
          options={ageOptions}
          name="min_age"
          placeholder="Select age"
          value={ageOptions.find((opt) => opt.value === validation.values.min_age) || null}
          onChange={(e: { value: any; }) => validation.setFieldValue("min_age", e?.value)}
          onBlur={() => validation.setFieldTouched("min_age", true)}  // Added
          classNamePrefix="react-select"                             // Added
          className={validation.touched.min_age && validation.errors.min_age ? "react-select-error" : ""}
        />
        {validation.touched.min_age && validation.errors.min_age && (
          <div className="invalid-feedback d-block">{validation.errors.min_age}</div>
        )}

      </Col>

      {/* Maximum Entry Age */}
      <Col md={4}>
        <Label className="fw-bold mb-1">Maximum Entry Age</Label>
        <Select
          options={ageOptions}
          name="max_age"
          placeholder="Select age"
          value={ageOptions.find((opt) => opt.value === validation.values.max_age) || null}
          onChange={(e: { value: any; }) => validation.setFieldValue("max_age", e?.value)}
          onBlur={() => validation.setFieldTouched("max_age", true)}
          classNamePrefix="react-select"
          className={validation.touched.max_age && validation.errors.max_age ? "react-select-error" : ""}
        />
        {validation.touched.max_age && validation.errors.max_age && (
          <div className="invalid-feedback d-block">{validation.errors.max_age}</div>
        )}
      </Col>

      
      <Col md={4}>
        <Label className="fw-bold mb-1">Maximum Maturity Age</Label>
        <Select
          options={ageOptions}
          name="max_maturity_age"
          placeholder="Select age"
          value={ageOptions.find((opt) => opt.value === validation.values.max_maturity_age) || null}
          onChange={(e: { value: any; }) => validation.setFieldValue("max_maturity_age", e?.value)}
          onBlur={() => validation.setFieldTouched("max_maturity_age", true)}
          classNamePrefix="react-select"
          className={validation.touched.max_maturity_age && validation.errors.max_maturity_age ? "react-select-error" : ""}
        />
        {validation.touched.max_maturity_age && validation.errors.max_maturity_age && (
          <div className="invalid-feedback d-block">{validation.errors.max_maturity_age}</div>
        )}
      </Col> 

      {/* Eligible Customers --> customer_eligibility */}
      <Col md={12}>
        <Label className="fw-bold mb-1">Eligible Customers</Label>
        <Input
          type="text"
          name="customer_eligibility"
          placeholder="Type here.."
          value={validation.values.customer_eligibility}
          onChange={validation.handleChange}
          invalid={!!(validation.touched.customer_eligibility && validation.errors.customer_eligibility)}
        />
        <FormFeedback>{validation.errors.customer_eligibility}</FormFeedback>
      </Col>

      {/* Medical Requirements */}
      <Col md={12}>
        <Label className="fw-bold mb-1">Medical Requirements</Label>
        <Input
          type="textarea"
          rows={4}
          name="medical_requirement"
          placeholder="Type here.."
          value={validation.values.medical_requirement}
          onChange={validation.handleChange}
          invalid={!!(validation.touched.medical_requirement && validation.errors.medical_requirement)}
        />
        <FormFeedback>{validation.errors.medical_requirement}</FormFeedback>
      </Col>
    </Row>
  );
};

export default EligibilityForm;
